import React, {useEffect, useState} from 'react';
import Api from '../../../../interface/api/visit';
import {CertificateMenuOptionItem} from "../../../../component/menu-item/certificate";
import {Pagination} from "../../../../component/paging";
import {Page} from "../../../../interface/model/page";
import {Search1} from "../../../../component/search";

import { makeStyles } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import TableContainer from '@material-ui/core/TableContainer';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Paper from '@material-ui/core/Paper';

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: '1px solid #e1e1e1',
        },
    },
});

export default function VisitorApprove() {
    const classes = useRowStyles();
    const [ visitorList, setVisitorList ] = useState<Page>();
    const [ pageNumber, setPageNumber ] = useState<number>(0);
    const [ searchInfo , setSearchInfo ] = useState({
        searchToDate : '',
        searchFromDate : '',
        visitorInfoSearchType : 'visitorName',
        searchValue : ''
    });
    const [open, setOpen] = useState({
        index : 0,
        flag : false,
        visitorExtendsInfo : {}
    });

    const [checkFlag, setCheckFlag] = useState(Array<{seq: string, flag: boolean}>);

    function getVisitApplicationDetail(visitor) {
        if(open.flag) {
            setOpen({...open,
                flag: false,
                index : visitor.seq,
                visitorExtendsInfo : {},
            })
        } else {
            Api.getVisitorInfo(visitor.seq).then(res => {
                setOpen({...open,
                    flag: true,
                    index : visitor.seq,
                    visitorExtendsInfo : res.data,
                })
            });
        }
    }

    function searchHandler() {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorCertificateInfoListBySearchAndPage(hostInfo.number, hostInfo.siteInfo.seq, searchInfo, pageNumber).then(res => {
            setVisitorList(res.data)
            let _arr = new Array();
            res.data.content.map(row => _arr.push({seq: row.seq, flag: false}));
            setCheckFlag(_arr);
        });
    }

    function pageMoveHandler(pageNumber) {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorCertificateInfoListBySearchAndPage(hostInfo.number, hostInfo.siteInfo.seq, searchInfo, pageNumber).then(res => {
            setVisitorList(res.data)
            let _arr = new Array();
            res.data.content.map(row => _arr.push({seq: row.seq, flag: false}));
            setCheckFlag(_arr);
        });
    }

    useEffect(() => {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorCertificateInfoList(hostInfo.number, hostInfo.siteInfo.seq).then(res => {
                setVisitorList(res.data);
                let _arr = new Array();
                res.data.content.map(row => _arr.push({seq: row.seq, flag: false}));
                setCheckFlag(_arr);
            });
    }, [])

    function onClickAllAgreeHandler(e) {
        let checkList = new Array();
        visitorList.content.map(row => checkList.push({ seq: row.seq, flag: e.target.checked }));
        setCheckFlag(checkList);
    }

    function onClickAgreeHandler(checkList, e) {
        setCheckFlag(
            checkFlag.map(row => row.seq === checkList.seq ?
                {...row, flag : e.target.checked} : {...row}
            )
        )
    }

    function selectSendBtnHandler() {
        checkFlag.map(row => row.flag ?
            Api.visitorCertificateRemind(row.seq).then(() => {
                alert('유해화학물질 교육 재이수 안내 문자가 발송되었습니다.')
            }) : {...row}
        )
    }

    function excelDownload() {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        let searchToDate = searchInfo.searchToDate;
        let searchFromDate = searchInfo.searchFromDate;
        let searchValue = searchInfo.searchValue;
        let visitorInfoSearchType = searchInfo.visitorInfoSearchType;
        window.location.href=`/v1/visit-info/certificate/excel/download?hostInfoSeq=${hostInfo.number}&searchToDate=${searchToDate}&searchFromDate=${searchFromDate}&searchValue=${searchValue}&visitorInfoSearchType=${visitorInfoSearchType}`;
    }

    return (
        <>
            <div className="add">
                <div className="btn_left">
                    <button
                        type="button"
                        className="nv_green_button m_skip"
                        style={{backgroundColor: '#00a99d'}}
                        onClick={selectSendBtnHandler}>
                        선택 문자발송
                    </button>
                    <button
                        type="button"
                        className="nv_green_button down_icon_btn m_skip"
                        style={{marginLeft: '5px'}}
                        onClick={excelDownload}>
                        엑셀 다운로드
                    </button>
                </div>
                <Search1 searchHandler={searchHandler} searchInfo={searchInfo} setSearchInfo={setSearchInfo}/>
                <div className="nv_table_box adminVersion">
                    <TableContainer component={Paper}>
                        <table className={"nv_table"} aria-label="a dense table">
                            <thead>
                                <tr>
                                    <th scope="row">
                                        <input type="checkbox" onClick={onClickAllAgreeHandler}
                                        />
                                    </th>
                                    <th scope="row" />
                                    <th align="center">방문자</th>
                                    <th align="center" className="m_skip">업체명</th>
                                    <th align="center" className="m_skip">생년월일</th>
                                    <th align="center" className="m_skip">연락처</th>
                                    <th align="center" className="m_skip">방문목적</th>
                                    <th align="center" className="m_skip">방문위치</th>
                                    <th align="center">방문기간</th>
                                    <th align="center" className="m_skip">방문시간</th>
                                    <th align="center" className="m_skip">차량번호</th>
                                    <th align="center" className="m_skip">상태</th>
                                    <th align="center" className="m_skip">수료일자</th>
                                    <th align="center">관리</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    visitorList!==undefined && visitorList.content.length > 0 ?
                                        visitorList.content.map((visitor, index) => (
                                        <>
                                            <tr className={classes.root} key={visitor.seq}>
                                                <td>
                                                    <input type="checkbox"
                                                           checked={checkFlag.filter(row => visitor.seq === row.seq && row.flag).length > 0}
                                                           onClick={(e) => onClickAgreeHandler(visitor, e)} />
                                                </td>
                                                <td>
                                                    <IconButton aria-label="expand row" size="small" onClick={() => getVisitApplicationDetail(visitor)}>
                                                        {(visitor.seq === open.index && open.flag) ? <KeyboardArrowDownIcon/> : <KeyboardArrowUpIcon />}
                                                    </IconButton>
                                                </td>
                                                <td align="center" className="m_skip">{visitor.visitorName}</td>
                                                <td align="center" className="m_skip">{visitor.visitorCompany}</td>
                                                <td align="center" className="m_skip">{visitor.visitorBirthDay}</td>
                                                <td align="center" className="m_skip">{visitor.visitorPhone}</td>
                                                <td align="center" className="m_skip">{visitor.visitorPurpose}</td>
                                                <td align="center" className="m_skip">{visitor.visitorLocation}</td>
                                                <td align="center">{`${visitor.visitStartDate}~${visitor.visitEndDate}`}</td>
                                                <td align="center" className="m_skip">{`${visitor.visitStartTime}시~${visitor.visitEndTime}시`}</td>
                                                <td align="center" className="m_skip">{visitor.visitorCar}</td>
                                                <td align="center" className="m_skip">{visitor.visitorStatus}</td>
                                                <td align="center" className="m_skip">{visitor.visitorCertificateDate}</td>
                                                <td align="center">
                                                    <CertificateMenuOptionItem items={[
                                                        {innerHTML: "수료증 등록 문자발송", sendType: "수료증등록", seq: visitor.seq},
                                                        {innerHTML: "재수료 문자발송", sendType: "재수료", seq: visitor.seq}
                                                    ]}/>
                                                </td>
                                            </tr>
                                            {
                                                (visitor.seq === open.index && open.flag) &&
                                                    <VisitorExtendsInfo visitorExtendsInfo={open.visitorExtendsInfo}/>
                                            }
                                        </>
                                    )) : <tr>
                                            <td colSpan={14} align="center">등록된 방문 정보가 없습니다.</td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </TableContainer>
                    <Pagination page={visitorList} pageMoveHandler={pageMoveHandler} />
                </div>
            </div>
        </>
    )
}

function VisitorExtendsInfo({visitorExtendsInfo}) {
    return (
        <tr className="visitor_more_info">
            <td colSpan={13}>
                <Collapse in={true} timeout="auto" unmountOnExit style={{border:'1px solid #eee', padding:'10px'}}>
                    <div className="pc_skip tpc_skip">
                        <table style={{width: '100%'}}>
                            <colgroup>
                            </colgroup>
                            <thead>
                                <tr>
                                    <td align="center" colSpan={3} style={{fontWeight:'bold'}}>추 가 정 보</td>
                                </tr>
                            </thead>
                            <tbody>
                               {
                                    visitorExtendsInfo.visitorApplicationInfo!=null ?
                                    <>
                                        <tr className="more_info_tit" style={{fontWeight:'bold'}}>
                                            <td align="center">업체명</td>
                                            <td align="center">생년월일</td>
                                            <td align="center">연락처</td>
                                            <td align="center">방문시간</td>
                                            <td align="center">차량번호</td>
                                        </tr>
                                        <tr>
                                            <td align="center">{visitorExtendsInfo.company}</td>
                                            <td align="center">{visitorExtendsInfo.birthDay}</td>
                                            <td align="center">{visitorExtendsInfo.phone}</td>
                                            <td align="center">{`${visitorExtendsInfo.visitorApplicationInfo.startTime}시~${visitorExtendsInfo.visitorApplicationInfo.endTime}시`}</td>
                                            <td align="center">{visitorExtendsInfo.car}</td>
                                        </tr>
                                        <tr className="more_info_tit" style={{fontWeight:'bold'}}>
                                            <td align="center">방문목적</td>
                                            <td colSpan={3} align="center">방문위치</td>
                                            <td align="center">상태</td>
                                        </tr>
                                        <tr>
                                            <td align="center">{visitorExtendsInfo.visitorApplicationInfo.visitPurpose}</td>
                                            <td colSpan={3} align="center">{visitorExtendsInfo.visitorApplicationInfo.visitLocation}</td>
                                            <td align="center">{visitorExtendsInfo.visitorStatus}</td>
                                        </tr>
                                    </>
                                    : <></>
                               }
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <table className="more_info_half_table" style={{float:'left'}}>
                            <colgroup>
                                <col style={{width:'50%'}} />
                                <col style={{width:'50%'}} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <td align="center" colSpan={2} style={{fontWeight:'bold'}}>문진표</td>
                                </tr>
                                <tr className="more_info_tit">
                                    <th align="center">위험지역방문여부</th>
                                    <th align="center">증상</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {
                                        visitorExtendsInfo.visitorSurveyInfo!=null
                                            ?   <>
                                                    <td align="center">
                                                        {
                                                            visitorExtendsInfo.visitorSurveyInfo.visitAreaDangerous === 'true'
                                                                ? `예(${visitorExtendsInfo.visitorSurveyInfo.visitAreas1},
                                                                ${visitorExtendsInfo.visitorSurveyInfo.visitAreas2},
                                                                ${visitorExtendsInfo.visitorSurveyInfo.visitAreas3})`
                                                                : '아니요'
                                                        }
                                                    </td>
                                                    <td align="center">
                                                        {visitorExtendsInfo.visitorSurveyInfo.symptoms.map(row => row)}
                                                    </td>
                                                </>
                                            : <>
                                                <td align="center">-</td>
                                                <td align="center">-</td>
                                            </>
                                    }
                                </tr>
                            </tbody>
                        </table>
                        <table className="more_info_half_table" style={{float: 'right'}}>
                            <colgroup>
                                <col style={{width:'50%'}} />
                                <col style={{width:'50%'}} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <td align="center" colSpan={2} style={{fontWeight:'bold'}}>중장비</td>
                                </tr>
                                <tr className="more_info_tit">
                                    <th align="center">첨부파일</th>
                                    <th align="center">관리</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {
                                        visitorExtendsInfo.visitorEquipmentInfo.fileInfos.length > 0
                                        ? <>
                                                <td align="center">
                                                    {visitorExtendsInfo.visitorEquipmentInfo.fileInfos[0].fileName}
                                                </td>
                                                <td align="center">
                                                    <a href={`/file/${visitorExtendsInfo.visitorEquipmentInfo.fileInfos[0].fileCategory}/${visitorExtendsInfo.visitorEquipmentInfo.fileInfos[0].saveFileName}`} >파일 다운로드</a>
                                                </td>
                                            </>
                                            : <>
                                                <td align="center">-</td>
                                                <td align="center">-</td>
                                            </>
                                    }
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div>
                        <table className="more_info_half_table" style={{float: 'left'}}>
                            <colgroup>
                                <col style={{width:'15%'}} />
                                <col style={{width:'45%'}} />
                                <col style={{width:'20%'}} />
                                <col style={{width:'20%'}} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <td align="center" colSpan={4} style={{fontWeight:'bold'}}>반 입 물 품</td>
                                </tr>
                                <tr className="more_info_tit">
                                    <th align="center">구분</th>
                                    <th align="center">시리얼번호</th>
                                    <th align="center">사용목적</th>
                                    <th align="center">비고</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    visitorExtendsInfo.visitorStuffInfos.map((row, index) => (
                                        <tr key={`stuffInfosKey-${index}`}>
                                            <td align="center">{row.category}</td>
                                            <td align="center">{row.serialNo}</td>
                                            <td align="center">{row.purpose}</td>
                                            <td align="center">{row.notice}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <table className="more_info_half_table" style={{float: 'right'}}>
                            <colgroup>
                                <col style={{width: '50%'}} />
                                <col style={{width: '50%'}} />
                            </colgroup>
                            <thead>
                            <tr>
                                <td align="center" colSpan={2} style={{fontWeight:'bold'}}>유해화학물질 교육 수료증</td>
                            </tr>
                            <tr className="more_info_tit">
                                <th align="center">첨부파일</th>
                                <th align="center">관리</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                {
                                    visitorExtendsInfo.visitorCertificateInfo.fileInfos.length > 0
                                        ?   <>
                                            <td align="center">
                                                {visitorExtendsInfo.visitorCertificateInfo.fileInfos[0].fileName}
                                            </td>
                                            <td align="center">
                                                <a href={`/file/${visitorExtendsInfo.visitorCertificateInfo.fileInfos[0].fileCategory}/${visitorExtendsInfo.visitorCertificateInfo.fileInfos[0].saveFileName}`} >파일 다운로드</a>
                                            </td>
                                        </>
                                        : <>
                                            <td align="center">-</td>
                                            <td align="center">-</td>
                                        </>
                                }
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Collapse>
            </td>
        </tr>
    )
}